import React, { ReactNode, useEffect } from "react";
import { useRouter } from "next/router";
import { useSession } from "../../../queries/authentication.query";
import { useLoginRoute } from "../../hooks/useLoginRoute";
import PageLoader from "../PageLoader/PageLoader";

type RenderChildren = () => ReactNode;

interface IProps {
  children: ReactNode | RenderChildren;
}

const ProtectedPage = ({ children }: IProps) => {
  const router = useRouter();
  const loginRoute = useLoginRoute();
  const { isLoggedIn, isFetched } = useSession();

  useEffect(() => {
    if (isFetched && !isLoggedIn) {
      router.replace(loginRoute);
    }
  }, [isFetched, isLoggedIn]);

  if (!isFetched || !isLoggedIn) {
    return <PageLoader />;
  }

  return <>{typeof children === "function" ? children() : children}</>;
};

export default ProtectedPage;
